<template>
  <div class="headerAvatar">
    <!-- <div class="head_notice" @click="toNoticeList">
      <a-icon type="bell" style="fontSize:19px;" theme="filled"/>
      <span v-if="isNotice"></span>
    </div> -->
    <a-dropdown >
      <div style="cursor: pointer;display:flex;align-items:center;">
        <a-avatar class="avatar" size="small" shape="circle"
                  :src="avatar"/>
        <span class="curr-user">{{user.username}}</span>
      </div>
      <a-menu style="width: 120px" slot="overlay">
        <a-menu-item @click="openProfile">
          <a-icon type="user"/>
          <span>个人中心</span>
        </a-menu-item>
        <a-menu-item @click="updatePassword">
          <a-icon type="key"/>
          <span>密码修改</span>
        </a-menu-item>
        <a-menu-divider></a-menu-divider>
        <a-menu-item @click="handleSettingClick">
          <a-icon type="setting"/>
          <span>系统定制</span>
        </a-menu-item>
        <a-menu-divider></a-menu-divider>
        <a-menu-item @click="logout">
          <a-icon type="logout"/>
          <span>退出登录</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <update-password
      @success="handleUpdate"
      @cancel="handleCancelUpdate"
      :user="user"
      :updatePasswordModelVisible="updatePasswordModelVisible">
    </update-password>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import UpdatePassword from '../personal/UpdatePassword'

export default {
  name: 'HeaderAvatar',
  components: {UpdatePassword},
  data () {
    return {
      updatePasswordModelVisible: false,
      isNotice:false
    }
  },
  computed: {
    ...mapState({
      settingBar: state => state.setting.settingBar.opened,
      user: state => state.account.user
    }),
    avatar () {
      return `static/avatar/${this.user.avatar}`
    }
  },
  mounted(){
  	/* this.$get('officialDoc/currentUser',{unread:0}).then((r) => {
    		if(r.data.rows&&r.data.rows.length>0){
    			this.isNotice=true;
    		}
    }) */
  },
  methods: {
    toNoticeList(){
      this.$router.push({
        path:'/noticeList'
      })
    },
    handleSettingClick () {
      this.setSettingBar(!this.settingBar)
    },
    openProfile () {
      this.$router.push('/profile')
    },
    updatePassword () {
      this.updatePasswordModelVisible = true
    },
    handleCancelUpdate () {
      this.updatePasswordModelVisible = false
    },
    handleUpdate () {
      this.updatePasswordModelVisible = false
      this.$message.success('更新密码成功，请重新登录系统')
      setTimeout(() => {
        this.logout()
      }, 1500)
    },
    logout () {
      this.$get(`logout/${this.user.id}`).then(() => {
        return new Promise((resolve, reject) => {
          this.$db.clear()
          location.reload()
        })
      }).catch(() => {
        this.$message.error('退出系统失败')
      })
    },
    ...mapMutations({setSettingBar: 'setting/setSettingBar'})
  }
}
</script>

<style lang="less" scoped>
  .ant-avatar-sm {
    width: 30px;
    height: 30px;
  }
  .avatar {
    margin: 10px 4px 10px 0;
    color: #1890ff;
    background: hsla(0, 0%, 100%, .85);
    vertical-align: middle;
  }
  .curr-user {
    font-weight: 600;
    // margin-left: 6px
  }
  .headerAvatar{
    display: flex;
    .head_notice{
      padding: 5px 40px 0 0;
      position: relative;
      span{
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: red;
        display: block;
        position: absolute;
        top: 21px;
        left: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/HeaderAvatar.vue